module.exports = __webpack_public_path__ + "static/media/SG.4170ba36.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/SG.svg
// module id = 356
// module chunks = 0